// Copyright (c) 2016 Deere & Company

import StatusChangeRequest, {getDefaultState} from '@deere/cps-it.warranty-model-factory/lib/status-change';
import actions from '../../actions-list';

const updateStatusChangeRequest = (state, action) =>
    StatusChangeRequest.update(state, {
        $set: action.data
    });

const addFile = (state, action) =>
    StatusChangeRequest.update(state, {
        file: {
            $push: [action.data]
        }
    });

const updateAgency = (state, action) =>
    StatusChangeRequest.update(state, {
        lawEnforcementDetails: {
            agency: {
                [action.name]: {
                    $set: action.data
                }
            }
        }
    });

const updateStatusRequestField = (state, action) =>
    StatusChangeRequest.update(state, {
        [action.name]: {
            $set: action.data
        }
    });

const deleteFile = (state, action) => {

    const index = state.file.findIndex(file => file.serialNumber === action.data.serialNumber && file.name === action.data.name);

    return StatusChangeRequest.update(state, {
        file: {
            $splice: [
                [
                    index,
                    1
                ]
            ]
        }
    });

};

const updateFile = (state, action) =>
    StatusChangeRequest.update(state, {
        file: {
            $set: action.files
        }
    });

const updateLastContactDetails = (state, action) =>
    StatusChangeRequest.update(state, {
        lastContactDetails: {
            [action.name]: {
                $set: action.data
            }
        }
    });

const updateNewStatus = (state, action) =>
    StatusChangeRequest.update(state, {
        newStatus: {
            $set: action.data
        }
    });

const updateLawEnforcementDetails = (state, action) =>
    StatusChangeRequest.update(state, {
        lawEnforcementDetails: {
            [action.name]: {
                $set: action.data
            }
        }
    });

const updateProduct = (state, action) =>
    StatusChangeRequest.update(state, {
        product: {
            $set: action.statusChangeProduct
        }
    });

const updateMachinePutBack = (state, action) =>
    StatusChangeRequest.update(state, {
        machinePutBack: {
            $set: action.data
        }
    });

const updateStatusChangeRequestObject = (state, action) => {

    const paramTypes = {
        addFile,
        city: updateAgency,
        comments: updateStatusRequestField,
        country: updateAgency,
        damageDesc: updateStatusRequestField,
        damageEventDate: updateStatusRequestField,
        damageEventDesc: updateStatusRequestField,
        deleteFile,
        lastContactDate: updateLastContactDetails,
        letterSentDate: updateLastContactDetails,
        name: updateAgency,
        newStatus: updateNewStatus,
        reportNumber: updateLawEnforcementDetails,
        state: updateAgency,
        stolenDate: updateLawEnforcementDetails
    };

    const reducerType = paramTypes[action.name];

    return reducerType(state, action);

};

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_STATUS_CHANGE_REQUEST_STATE]: updateStatusChangeRequest,
        [actions.UPDATE_STATUS_CHANGE_PRODUCT_SUCCESS]: updateProduct,
        [actions.UPDATE_STATUS_CHANGE_SELECTED_MACHINE_PUT_BACK]: updateMachinePutBack,
        [actions.UPDATE_STATUS_CHANGE_REQUEST_OBJECT]: updateStatusChangeRequestObject,
        [actions.UPDATE_STATUS_CHANGE_REQUEST_OBJECT_FILE_LIST]: updateFile
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/status-change-request/reducers/status-change-request.js